import _ from "lodash";
import {PRODUCT_BLOG_POST_PROMPTS} from "../constants/product-blog-post.constant";
import {findTextIndexInContentLine, isTextFoundInContentLine} from "../../content/utils/blog-content-util";

export {
    prepareTitlePromptText,
    prepareContentPromptText,
    prepareExpandContentPromptText,
    prepareExpandSectionContentPromptText,
    prepareRewriteSectionTitlePromptText,
    prepareRewriteSectionContentPromptText,
    prepareProductLinkDetails,
    prepareExtractKeyWordsAndMapLinksPromptText,
    prepareKeywordLinkMapping,
}
const prepareTitlePromptText = (url, toneOfVoice, contentTags) => {
    let promptText = PRODUCT_BLOG_POST_PROMPTS.TITLE.prompt + '\n';

    if (!_.isEmpty(url)) {
        promptText += 'URL: "' + url + '"\n';
    }

    if (!_.isEmpty(toneOfVoice)) {
        promptText += 'Tone of Voice: "' + toneOfVoice + '"\n';
    }

    if (!_.isEmpty(contentTags)) {
        promptText += 'Keywords: "' + contentTags + '"\n';
    }

    return promptText;
}

const prepareContentPromptText = (title, url, toneOfVoice, contentTags) => {
    let promptText = PRODUCT_BLOG_POST_PROMPTS.BLOG_CONTENT.prompt + '\n';

    if (!_.isEmpty(title)) {
        promptText += 'Title: "' + title + '"\n';
    }

    if (!_.isEmpty(url)) {
        promptText += 'URL: "' + url + '"\n';
    }

    if (!_.isEmpty(toneOfVoice)) {
        promptText += 'Tone of Voice: "' + toneOfVoice + '"\n';
    }

    if (!_.isEmpty(contentTags)) {
        promptText += 'Content: "' + contentTags + '"\n';
    }

    return promptText;
}

const prepareExpandContentPromptText = (title, url, toneOfVoice, contentLine) => {
    let promptText = PRODUCT_BLOG_POST_PROMPTS.EXPAND_CONTENT.prompt + '\n';

    if (!_.isEmpty(title)) {
        promptText += 'Title: "' + title + '"\n';
    }

    if (!_.isEmpty(url)) {
        promptText += 'URL: "' + url + '"\n';
    }

    if (!_.isEmpty(toneOfVoice)) {
        promptText += 'Tone of Voice: "' + toneOfVoice + '"\n';
    }

    if (!_.isEmpty(contentLine)) {
        promptText += 'Content: "' + contentLine + '"\n';
    }

    return promptText;
}

const prepareExpandSectionContentPromptText = (contentLine) => {
    let promptText = PRODUCT_BLOG_POST_PROMPTS.EXPAND_CONTENT.prompt + '\n';

    if (!_.isEmpty(contentLine)) {
        promptText += 'Content: "' + contentLine + '"\n';
    }

    return promptText;
}

const prepareRewriteSectionTitlePromptText = (sectionTitle, content) => {
    let promptText = PRODUCT_BLOG_POST_PROMPTS.REWRITE_SECTION_TITLE.prompt + '\n';

    if (!_.isEmpty(sectionTitle)) {
        promptText += 'Section Title: "' + sectionTitle + '"\n';
    }

    if (!_.isEmpty(content)) {
        promptText += 'Content: "' + content + '"\n';
    }

    return promptText;
}

const prepareRewriteSectionContentPromptText = (content) => {
    let promptText = PRODUCT_BLOG_POST_PROMPTS.REWRITE_CONTENT.prompt + '\n';

    if (!_.isEmpty(content)) {
        promptText += 'Content: "' + content + '"\n';
    }

    return promptText;
}

const prepareExtractKeyWordsAndMapLinksPromptText = (content, productUrls) => {
    let promptText = PRODUCT_BLOG_POST_PROMPTS.EXTRACT_KEYWORDS_AND_MAP_LINKS.prompt + '\n';

    if (!_.isEmpty(content)) {
        promptText += 'Content: "' + content + '"\n';
    }

    if (!_.isEmpty(productUrls)) {
        promptText += 'URLs: "' + _.join(_.shuffle(productUrls), ', ') + '"\n';
    }

    return promptText;
}

const prepareContentHtml = (contentLines) => {
    let contentHtml = '';

    contentLines.forEach((line) => {
        if (!_.isEmpty(line)) {
            contentHtml += '<p>' + line + '</p>';
        }
    });

    return contentHtml;
}

const prepareProductLinkDetails = (productsList, collectionsList) => {
    const newProductLinkFields = [];
    let onlineStoreBaseUrl = '';

    _.forEach(productsList, (product, key) => {
        newProductLinkFields.push({
            attribute: product.id,
            title: product.title,
            type: 'text',
            value: '',
            url: product.onlineStoreUrl,
            nodeType: 'product',
        });

        if (!onlineStoreBaseUrl) {
            onlineStoreBaseUrl = _.split(product.onlineStoreUrl, '.com')[0];
            onlineStoreBaseUrl += '.com';
        }
    });

    _.forEach(collectionsList, (collection, key) => {
        newProductLinkFields.push({
            attribute: collection.id,
            title: collection.title,
            type: 'text',
            value: '',
            url: onlineStoreBaseUrl + '/collections/' + collection.handle,
            nodeType: 'collection',
        });
    });

    const allUrls = _.map(newProductLinkFields, 'url');
    return {productLinkFields: newProductLinkFields, productUrls: allUrls};
}

const prepareKeywordLinkMapping = (generatedText, productLinkFields, inputText) => {
    const mappingLinks = [];
    const mappingTexts = [];
    const mappedProductLinks = [];

    const templateProductLinkFields = [...productLinkFields];
    const templateProductLinkFieldsByUrlMap = _.keyBy(templateProductLinkFields, 'url');

    let keywordText, keywordLink;
    _.forEach(_.split(generatedText, '\n'), (line) => {
        if (!_.isEmpty(line) && line.indexOf('https') !== -1) {
            const mapDetail = _.split(line, ' = ');
            keywordText = _.trim(mapDetail[0]);
            keywordLink = _.trim(mapDetail[1]);

            keywordText = _.replace(keywordText, /"/g, '');
            keywordText = _.replace(keywordText, /'/g, '');
            keywordLink = _.replace(keywordLink, /"/g, '');
            keywordLink = _.replace(keywordLink, /'/g, '');

            const titleWords = _.split(keywordText, ' ');
            const firstWord = titleWords[0];

            if (_.isNumber(_.toNumber(firstWord))) {
                keywordText = _.trim(_.replace(keywordText, firstWord, ''));
            }

            if (!_.isEmpty(keywordText) && templateProductLinkFieldsByUrlMap[keywordLink] &&
                mappedProductLinks.indexOf(keywordLink) === -1 &&
                mappingTexts.indexOf(keywordText) === -1 &&
                isTextFoundInContentLine(inputText, keywordText)) {

                const textIndex = findTextIndexInContentLine(inputText, keywordText);

                const productLinkField = _.cloneDeep(templateProductLinkFieldsByUrlMap[keywordLink]);
                productLinkField.value = keywordText;
                productLinkField.textIndex = textIndex;

                mappingLinks.push(productLinkField);
                mappingTexts.push(keywordText);

                mappedProductLinks.push(keywordLink);
            }
        }
    });

    return _.chunk(_.shuffle(mappingLinks), 6)[0];
}
